import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../../app/apiBaseQuery";

export const FrontAPI = createApi({
  reducerPath: "FrontAPI",
  baseQuery,
  endpoints: (builder) => ({
    getMetaInfo: builder.mutation({
      query: (params) => ({
        url: "admin/getSeoMetaById",
        method: "POST",
        body: params,
      }),
    }),

    submitQuery: builder.mutation({
      query: (params) => ({
        url: "user/submitContactQuery",
        method: "POST",
        body: params,
      }),
    }),

    getZoomMeetings: builder.query({
      query: ({ jobId = "", status = "" } = {}) => ({
        url: `zoom/getMeetings?jobId=${jobId}&status=${status}`,
        method: "GET",
      }),
    }),

    createScheduleMeeting: builder.mutation({
      query: (params) => ({
        url: "zoom/scheduleMeeting",
        method: "POST",
        body: params,
      }),
    }),

    respondToMeetings: builder.mutation({
      query: (params) => ({
        url: "zoom/respondToMeeting",
        method: "POST",
        body: params,
      }),
    }),

    getCustomerPaymentMethods: builder.query({
      query: () => ({
        url: "user/getCustomerPaymentMethods",
        method: "POST",
        body: {},
      }),
    }),
    deletePaymentMethod: builder.mutation({
      query: (params) => ({
        url: "user/deletePaymentMethod",
        method: "POST",
        body: params,
      }),
    }),
    setDefaultPaymentMethod: builder.mutation({
      query: (params) => ({
        url: "user/setDefaultPaymentMethod",
        method: "POST",
        body: params,
      }),
    }),

    createOrUpdateJob: builder.mutation({
      query: ({ data, token }) => ({
        url: "user/createOrUpdateJob",
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getMyReferredEmployers: builder.mutation({
      query: (params) => ({
        url: 'user/getMyReferredEmployers',
        method: 'POST',
        body: params,
      }),
    }),
    getMyAffiliateCommissions: builder.mutation({
      query: (params) => ({
        url: 'admin/getMyAffiliateCommissions',
        method: 'POST',
        body: params,
      }),
    }),
    getGeneralSettings: builder.query({
    query: () => ({
        url: "user/getGeneralSettings",
        method: "GET",
    }),
}),
  }),
});

export const {
      useGetGeneralSettingsQuery,
  useGetMetaInfoMutation,
  useSubmitQueryMutation,
  useCreateOrUpdateJobMutation,
  useCreateScheduleMeetingMutation,
  useGetZoomMeetingsQuery,
  useRespondToMeetingsMutation,
  useGetCustomerPaymentMethodsQuery,
  useDeletePaymentMethodMutation,
  useSetDefaultPaymentMethodMutation,
  useGetMyReferredEmployersMutation,
  useGetMyAffiliateCommissionsMutation
} = FrontAPI;
